import { render, staticRenderFns } from "./MessageLength.vue?vue&type=template&id=173825b4&scoped=true&"
import script from "./MessageLength.vue?vue&type=script&lang=ts&"
export * from "./MessageLength.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173825b4",
  null
  
)

export default component.exports